const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-3345371a-2dd6-48c8-a7c6-6f11753843b0 {\n        fill: #5e3524;\n      }\n\n      .uuid-6bbc959f-c959-4281-93a2-b1f627b85ee1, .uuid-1c37321e-997f-44b4-8bed-200bd10f4003 {\n        fill: none;\n        stroke: #e8e4db;\n        stroke-linejoin: round;\n      }\n\n      .uuid-1c37321e-997f-44b4-8bed-200bd10f4003 {\n        stroke-width: 2px;\n      }\n    "));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "uuid-db0c1ada-8949-4092-a086-8455b1bf13c9",
  "data-name": "Circles"
}, /*#__PURE__*/React.createElement("circle", {
  className: "uuid-3345371a-2dd6-48c8-a7c6-6f11753843b0",
  cx: 22,
  cy: 21.95,
  r: 22
}));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "uuid-36acf8d5-9940-462c-86df-d33d11d3aae7",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "uuid-1c37321e-997f-44b4-8bed-200bd10f4003",
  d: "M23.69,7.8h-3.38c-.11,0-.22.05-.3.13l-1.74,1.74c-.13.13-.16.34-.08.51l1.45,2.71c.08.14.22.23.38.23h3.94c.16,0,.3-.09.38-.23l1.45-2.71c.09-.17.06-.37-.08-.51l-1.74-1.74c-.08-.08-.19-.13-.3-.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-1c37321e-997f-44b4-8bed-200bd10f4003",
  d: "M19.68,13.88l-2.24,19.03c-.04.32.1.63.37.81l3.57,2.46c.29.2.68.2.98,0l3.83-2.64c.26-.18.4-.49.37-.81l-2.23-18.85c-.05-.43-.42-.76-.86-.76h-2.93c-.44,0-.81.33-.86.76Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-6bbc959f-c959-4281-93a2-b1f627b85ee1",
  d: "M24.47,15.16s-5.33,3.71-5.39,3.75"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-6bbc959f-c959-4281-93a2-b1f627b85ee1",
  d: "M24.67,17.22s-5.77,4.02-5.82,4.07"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-6bbc959f-c959-4281-93a2-b1f627b85ee1",
  d: "M24.01,7.95s-5.04,3.51-5.1,3.56"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-6bbc959f-c959-4281-93a2-b1f627b85ee1",
  d: "M25.23,9.3s-5.4,3.76-5.46,3.81"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-6bbc959f-c959-4281-93a2-b1f627b85ee1",
  d: "M25.14,20.85s-6.76,4.72-6.84,4.78"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-6bbc959f-c959-4281-93a2-b1f627b85ee1",
  d: "M25.35,22.91s-7.21,5.02-7.29,5.08"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-6bbc959f-c959-4281-93a2-b1f627b85ee1",
  d: "M25.88,27.17s-8.36,5.82-8.45,5.89"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-6bbc959f-c959-4281-93a2-b1f627b85ee1",
  d: "M26.09,29.22s-7.53,5.24-7.62,5.32"
}));
function SvgRepozeIconCategoryUniforms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepozeIconCategoryUniforms);
export default __webpack_public_path__ + "static/media/repoze_icon_category-uniforms.addd849fc852e75eeb0ada175e7a9ea3.svg";
export { ForwardRef as ReactComponent };